module.exports = __webpack_public_path__ + "assets/img/banner7.4d8c0c1f.png";